import { styles } from '../styles';

export const elementStyles = [
  styles.interactable,
  ({ disabled }: { disabled?: boolean }) => (disabled ? styles.disabled : null),
];
